import React from "react";
import { Label } from "@/components/ui/label";
import { TxtField, TxtArea, RichField, NumField, SelectField } from "../fields";
import ImageUpload from "@/components/ImageUpload";

export default function BasicTab({ inst, set, categories, lang }) {
  return (
    <div className="grid md:grid-cols-2 gap-6 p-6 rounded-2xl border border-border bg-card">
      <TxtField label="Slug" testid="f-slug" value={inst.slug} onChange={(v) => set("slug", v.toLowerCase().replace(/[^a-z0-9-]/g, "-"))} />
      <div>
        <Label className="text-xs uppercase tracking-wider text-muted-foreground">{lang === "id" ? "Kategori (bisa lebih dari satu)" : "Categories (multi-select)"}</Label>
        <div className="mt-2 p-3 rounded-xl border border-border bg-secondary/30 max-h-48 overflow-auto space-y-1.5" data-testid="f-categories">
          {categories.length === 0 && <div className="text-xs text-muted-foreground">{lang === "id" ? "Belum ada kategori. Buat dulu di menu Kategori." : "No categories yet. Create them in the Kategori menu."}</div>}
          {categories.map((c) => {
            const ids = inst.category_ids || (inst.category_id ? [inst.category_id] : []);
            const checked = ids.includes(c.id);
            const toggle = () => {
              const next = checked ? ids.filter(x => x !== c.id) : [...ids, c.id];
              set("category_ids", next);
              // Keep primary category_id in sync (first item, for backward compat)
              set("category_id", next[0] || null);
            };
            return (
              <label key={c.id} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-secondary/60 px-2 py-1 rounded" data-testid={`f-cat-${c.slug}`}>
                <input type="checkbox" checked={checked} onChange={toggle} className="rounded" />
                <span>{lang === "id" ? c.name_id : c.name_en}</span>
                <span className="text-[10px] text-muted-foreground font-mono ml-auto">{c.slug}</span>
              </label>
            );
          })}
        </div>
      </div>
      <TxtField label="Nama (ID)" testid="f-name-id" value={inst.name_id} onChange={(v) => set("name_id", v)} />
      <TxtField label="Nama (EN)" testid="f-name-en" value={inst.name_en} onChange={(v) => set("name_en", v)} />
      <TxtArea label="Deskripsi Singkat (ID)" testid="f-short-id" value={inst.short_description_id} onChange={(v) => set("short_description_id", v)} />
      <TxtArea label="Deskripsi Singkat (EN)" testid="f-short-en" value={inst.short_description_en} onChange={(v) => set("short_description_en", v)} />
      <RichField label="Deskripsi (ID)" testid="f-desc-id" value={inst.description_id} onChange={(v) => set("description_id", v)} />
      <RichField label="Deskripsi (EN)" testid="f-desc-en" value={inst.description_en} onChange={(v) => set("description_en", v)} />
      <RichField label="Petunjuk (ID)" testid="f-inst-id" value={inst.instructions_id} onChange={(v) => set("instructions_id", v)} />
      <RichField label="Petunjuk (EN)" testid="f-inst-en" value={inst.instructions_en} onChange={(v) => set("instructions_en", v)} />
      <div className="md:col-span-2">
        <ImageUpload
          label={lang === "id" ? "Gambar Cover Instrumen" : "Instrument Cover Image"}
          value={inst.cover_image}
          onChange={(url) => set("cover_image", url)}
          previewSize="cover"
          hint={lang === "id"
            ? "Rasio 4:5 (mis. 1600×2000 px), maks. 1 MB. Tampil sama di Beranda, Katalog, dan halaman detail."
            : "4:5 ratio (e.g. 1600×2000 px), max 1 MB. Shown the same on Home, Catalogue, and the detail page."}
          testid="f-cover"
        />
      </div>
      <div className="md:col-span-2">
        <ImageUpload
          label={lang === "id" ? "Gambar Cover (EN), opsional" : "Cover Image (EN), optional"}
          value={inst.cover_image_en}
          onChange={(url) => set("cover_image_en", url)}
          previewSize="cover"
          hint={lang === "id"
            ? "Tampil di halaman berbahasa Inggris. Kosongkan untuk memakai cover di atas."
            : "Shown on English pages. Leave empty to use the cover above."}
          testid="f-cover-en"
        />
      </div>
      <SelectField label={lang === "id" ? "Status Pengembangan" : "Development Status"} testid="f-devstatus" value={inst.development_status} onChange={(v) => set("development_status", v)} options={[
        { value: "explorasi", label: "Explorasi" }, { value: "dalam_pengembangan", label: "Dalam Pengembangan" },
        { value: "berbasis_kriteria", label: "Berbasis Kriteria" }, { value: "norma_sementara", label: "Norma Sementara" },
        { value: "tervalidasi", label: "Tervalidasi" },
      ]} />
      <div className="grid grid-cols-3 gap-3">
        <NumField label="Durasi" testid="f-duration" value={inst.duration_minutes} onChange={(v) => set("duration_minutes", v)} />
        <NumField label="Usia min" testid="f-agemin" value={inst.target_age_min} onChange={(v) => set("target_age_min", v)} />
        <NumField label="Usia max" testid="f-agemax" value={inst.target_age_max} onChange={(v) => set("target_age_max", v)} />
      </div>
      <TxtArea label="Disclaimer (ID)" testid="f-disc-id" value={inst.disclaimer_id} onChange={(v) => set("disclaimer_id", v)} />
      <TxtArea label="Disclaimer (EN)" testid="f-disc-en" value={inst.disclaimer_en} onChange={(v) => set("disclaimer_en", v)} />
    </div>
  );
}
